// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"yK-z","carouselContainer":"zK-z"};